"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUtilityClasses = exports.getQuantityPickerSlots = exports.TooltipContainer = exports.TooltipArrow = exports.QuantityPickerRoot = exports.InputRoot = exports.IconButtonRoot = void 0;
var _react = require("@floating-ui/react");
var _base = require("@ori-ui/mui-bundle/base");
var _material = require("@ori-ui/mui-bundle/material");
var _IconButton = _interopRequireWildcard(require("../IconButton"));
var _utils = require("../utils");
var _constants = require("./constants");
var _quantityPickerClasses = require("./quantityPickerClasses");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getQuantityPickerSlots = ownerState => {
  const {
    disabled,
    focused,
    readOnly,
    size,
    variant
  } = ownerState;
  return {
    root: ['root', disabled && 'disabled', readOnly && 'readOnly', `${variant}${(0, _utils.capitalize)(size)}`],
    input: ['input', focused && 'focused', `size${(0, _utils.capitalize)(size)}`],
    iconButton: ['iconButton', `${variant}${(0, _utils.capitalize)(size)}`],
    increaseButton: ['increaseButton'],
    decreaseButton: ['decreaseButton']
  };
};
exports.getQuantityPickerSlots = getQuantityPickerSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getQuantityPickerSlots(ownerState);
  return (0, _base.unstable_composeClasses)(slots, _quantityPickerClasses.getQuantityPickerUtilityClass, classes);
};
exports.useUtilityClasses = useUtilityClasses;
const QuantityPickerRoot = exports.QuantityPickerRoot = (0, _material.styled)('div', {
  name: 'MuiOriQuantityPicker',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root, ownerState.disabled && styles.disabled, ownerState.readOnly && styles.readOnly, styles[`${ownerState.variant}${(0, _utils.capitalize)(ownerState.size)}`]]
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  gridTemplateColumns: ownerState.cssProps.holder.gridTemplateColumns,
  justifyContent: 'space-between',
  alignContent: 'space-around',
  boxSizing: 'border-box',
  minWidth: ownerState.cssProps.holder.minWidth,
  width: ownerState.cssProps.holder.width,
  height: ownerState.cssProps.holder.height,
  minHeight: _constants.TEXT_MEDIUM_BUTTON_SIZE,
  ...(ownerState.variant === 'contained' && ownerState.size === 'medium' && {
    minHeight: _constants.CONTAINED_MEDIUM_BUTTON_MIN_HEIGHT
  }),
  ...(ownerState.variant === 'contained' && ownerState.size === 'large' && {
    minHeight: _constants.CONTAINED_LARGE_BUTTON_MIN_HEIGHT
  }),
  overflow: 'hidden',
  background: ownerState.cssProps.holder.background,
  padding: ownerState.cssProps.holder.padding,
  borderRadius: ownerState.cssProps.holder.borderRadius,
  boxShadow: ownerState.cssProps.holder.boxShadow,
  ...(ownerState.expandOnFocus && {
    gridTemplateColumns: '0 3.4rem 0',
    minHeight: '2.6rem',
    transition: theme.transitions.create(['width', 'translate'], {
      duration: theme.transitions.duration.short
    }),
    ...(ownerState.focused && {
      gridTemplateColumns: '2.6rem 3.4rem 2.6rem',
      minWidth: '10.2rem',
      width: '10.2rem'
    })
  })
}));
const InputRoot = exports.InputRoot = (0, _material.styled)(_material.InputBase, {
  name: 'MuiOriQuantityPicker',
  slot: 'Input',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.input, ownerState.focused && styles.focused, styles[`size${(0, _utils.capitalize)(ownerState.size)}`]]
})(({
  theme,
  ownerState
}) => ({
  margin: 0,
  padding: 0,
  minWidth: ownerState.cssProps.input.minWidth,
  width: ownerState.cssProps.input.width,
  height: ownerState.cssProps.input.height,
  transition: theme.transitions.create(['border'], {
    duration: theme.transitions.duration.short
  }),
  border: '1px solid transparent',
  borderRadius: theme.shape.mediumComponentRadius,
  alignSelf: 'center',
  fontSize: _constants.INPUT_FONT_SIZE,
  '&:hover': {
    border: `1px solid ${theme.palette.grey[200]}`,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      borderColor: theme.palette.grey[200]
    }
  },
  ...(ownerState.focused && {
    border: `1px solid ${theme.palette.grey[200]}`
  }),
  ...(ownerState.readOnly && {
    border: 'none'
  }),
  [`& input`]: {
    fontSize: _constants.INPUT_FONT_SIZE,
    textAlign: 'center',
    padding: 0,
    ...(ownerState.readOnly && {
      cursor: 'default'
    })
  },
  ...(ownerState.disabled && {
    color: theme.palette.text.disabled,
    borderColor: 'transparent'
  })
}));
const IconButtonRoot = exports.IconButtonRoot = (0, _material.styled)(_IconButton.default, {
  name: 'MuiOriQuantityPicker',
  slot: 'iconButton',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.iconButton, styles[`${ownerState.variant}${(0, _utils.capitalize)(ownerState.size)}`]]
})(({
  theme,
  ownerState
}) => ({
  fontSize: ownerState.cssProps.button.fontSize,
  width: ownerState.cssProps.button.width,
  height: ownerState.cssProps.button.height,
  ...(ownerState.tooltipTrigger && {
    background: 'transparent',
    color: theme.palette.grey.A400,
    cursor: 'default',
    '&:hover': {
      background: 'transparent !important',
      color: `${theme.palette.grey.A400} !important`
    },
    '&:focus': {
      background: 'transparent !important',
      color: `${theme.palette.grey.A400} !important`
    },
    [`&.${_IconButton.iconButtonClasses.focusVisible}`]: {
      background: 'transparent',
      color: theme.palette.grey.A400
    }
  }),
  ...(ownerState.expandOnFocus && {
    display: 'none',
    ...(ownerState.focused && {
      display: 'initial',
      lineHeight: 0.75
    })
  })
}));
const TooltipContainer = exports.TooltipContainer = (0, _material.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  padding: theme.spacing(4),
  maxWidth: 200,
  margin: 0,
  background: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.primary,
  fontSize: theme.typography.body1.fontSize,
  boxShadow: theme.shadows[3]
}));
const TooltipArrow = exports.TooltipArrow = (0, _material.styled)(_react.FloatingArrow)(({
  theme
}) => ({
  fill: theme.palette.common.white
}));
//# sourceMappingURL=quantityPickerStyled.js.map